import { Component,  ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialService } from '../../../services/material.services';
import { MainService } from '../../../services/main.services';


@Component({
  selector: 'app-material-scan',
  templateUrl: './material-scan.component.html',
  styleUrl: './material-scan.component.scss'
})
export class MaterialScanComponent implements AfterViewInit, OnDestroy {
  camp_id: any;
  claw_camp_id: any;
  group_id: any;
  mat_id : any;
  dataParam : any;
  isMobile = false;
  videoDevices: MediaDeviceInfo[] = [];
  selectedDeviceId: string | undefined;
  frontCameraId: string | undefined;
  rearCameraId: string | undefined;
  osInfo: string = 'Sistema desconocido';
  browserInfo: string = 'Navegador desconocido';
  deviceBrand: string = '';

  capturas: number = 1;
  capturesTaken: number = 0;
  capturedImages: string[] = [];
  croppedImages: string[] = [];
  cameraPermissionError = false;
  isCapturing: boolean = false;

  isPreviewing: boolean = false;
  previewImage: string = '';
  countdown: number = 3;
  private countdownInterval: any;
  orientacion : number = 0;
  isMirrored = false;
  recuadroVisble: boolean = false;

  private stream: MediaStream | undefined;

   constructor(private router: Router,
     private _params: ActivatedRoute,
     private matService : MaterialService,
       private mainServide : MainService
   ) {
      this._params.params.subscribe((params : any) => {


     this.dataParam = this.mainServide.deserializeObj(params.payload);

            this.camp_id = this.dataParam.camp_id;
            this.claw_camp_id = this.dataParam.claw_camp_id;
            this.group_id = this.dataParam.id_grupo;
            this.matName = this.dataParam.mat_nombre;
            this.mat_id = this.dataParam.mat_id;
            this.detectMobileDevice();
            this.detectSOAndBrowser();
       })

   }
   @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;
   @ViewChild('canvas') canvasRef!: ElementRef<HTMLCanvasElement>;
   capturedImage: string= "";
   croppedImage: string  = "";
   matName = "Material";

  private detectMobileDevice(): void {
    if ((navigator as any).userAgentData) {
      this.isMobile = (navigator as any).userAgentData.mobile;
    } else {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      this.isMobile = /android|iphone|ipad|ipod/i.test(userAgent);
    }
  }

  private detectSOAndBrowser(): void {
    if ((navigator as any).userAgentData) {
      const uaData = (navigator as any).userAgentData;

      this.osInfo = uaData.platform;

      const mainBrand = uaData.brands.find((b: any) => b.brand !== 'Not/A)Brand' && b.brand !== 'Chromium');
      const browser = mainBrand || uaData.brands[0];
      if (browser) {
        this.browserInfo = `${browser.brand} ${browser.version}`;
      }

      uaData.getHighEntropyValues(['platformVersion', 'model'])
        .then((ua: any) => {
          if (ua.platformVersion) {
            this.osInfo += ` ${ua.platformVersion}`;
          }
          if (ua.model && ua.model.length > 0) {
            this.deviceBrand = ua.model;
          }
        });

    } else {
      const userAgent = navigator.userAgent;

      if (userAgent.includes("Win")) this.osInfo = "Windows";
      else if (userAgent.includes("Mac")) this.osInfo = "Mac OS";
      else if (userAgent.includes("Linux")) this.osInfo = "Linux";
      else if (userAgent.includes("Android")) this.osInfo = "Android";
      else if (userAgent.includes("like Mac")) this.osInfo = "iOS"; 

      let browserName = "Desconocido";
      if (userAgent.includes("Firefox")) browserName = "Firefox";
      else if (userAgent.includes("SamsungBrowser")) browserName = "Samsung Internet";
      else if (userAgent.includes("Opera") || userAgent.includes("OPR")) browserName = "Opera";
      else if (userAgent.includes("Trident")) browserName = "Internet Explorer";
      else if (userAgent.includes("Edge")) browserName = "Edge";
      else if (userAgent.includes("Chrome")) browserName = "Chrome";
      else if (userAgent.includes("Safari")) browserName = "Safari";
      this.browserInfo = browserName;
    }

    console.log("browser", this.browserInfo, this.osInfo, this.deviceBrand);
  }

  onCancel() {
    if(this.mat_id == 0){
       this.router.navigate(['/material-list/' + this.claw_camp_id + '/' + this.dataParam.box_id]);
    }else{
       this.router.navigate(['material-version-list/'+ this.claw_camp_id  + '/' + this.camp_id + '/' +  this.dataParam.box_id + '/'+ this.group_id]);
    }
   
  }

  currentmask = 'assets/example-masks/noimage.png'

  onCapture(item:any){
     this.router.navigate(['/material-compare']);
  }



  ngOnInit(): void {
  Swal.close();
  this.getMaterial();

  this.capturesTaken = 0;
  this.capturedImages = [];
  this.croppedImages = [];
  this.isCapturing = false;
  }
  loaded = false;
  mat_info : any = {};
  getMaterial(){
           Swal.fire({
               title: 'Cargando datos...',
               text: 'Esto puede tardar unos segundos',
               allowOutsideClick: false,
               didOpen: () => {
                 Swal.showLoading();
               }
           });
        console.log("camp_data", this.camp_id, this.claw_camp_id, this.group_id,this._params);
         this.matService.getMatData(this.camp_id, this.claw_camp_id, this.group_id).subscribe((x:any)=>{
          console.log(x.message, x.data);
          if(x.message === 'Success'){
            console.log(x.data);
    
               this.mat_info = x.data
               if(this.mat_info.length != 0){
                this.capturas = this.mat_info[0].capturas;
                this.orientacion = this.mat_info[0].orientacion;
                this.currentmask = this.matService.getMaskUrl(this.mat_info[0].img);
               }
               
              //this.versiones = x.data.versio
              this.loaded = true;
              Swal.close();
          }else{
            Swal.close();
            Swal.fire('Error', 'Oops, algo salió mal, por favor intente más tarde', 'error');
          }
         });
        
  }

  ngAfterViewInit(): void {
    this.initializeCamera();
  }

  async initializeCamera(): Promise<void> {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.videoDevices = devices.filter(device => device.kind === 'videoinput');
        if (this.videoDevices.length > 0) {

          this.cameraPermissionError = false;

          const rearCamera = this.videoDevices.find(d => d.label.toLowerCase().includes('back') || d.label.toLowerCase().includes('trasera'));
          const frontCamera = this.videoDevices.find(d => d.label.toLowerCase().includes('front') || d.label.toLowerCase().includes('frontal'));

          this.rearCameraId = rearCamera?.deviceId || this.videoDevices.find(d => !d.label.toLowerCase().includes('front'))?.deviceId;
          this.frontCameraId = frontCamera?.deviceId || this.videoDevices.find(d => d.label.toLowerCase().includes('front'))?.deviceId;
          
          this.selectedDeviceId = this.rearCameraId || this.videoDevices[0].deviceId;
          this.startCamera(this.selectedDeviceId);
          
        } else {

          this.startCamera(undefined as any);
        }
      } catch (err) {
        console.error('Error al enumerar dispositivos: ', err);
        this.cameraPermissionError = true;
      }
    } else {
      this.cameraPermissionError = true;
      console.error('MediaDevices API no soportada.');
    }
  }

     camerror ="";
     
  startCamera(deviceId: string): void {    
    Swal.showLoading();
    const constraints: MediaStreamConstraints = {
      video: {
        deviceId: deviceId ? { exact: deviceId } : undefined,
        aspectRatio: { ideal: 1 } 
      }
    };

    navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        this.camerror = "";
        this.cameraPermissionError = false;
        this.stream = stream;
        const video = this.videoRef.nativeElement;
        video.srcObject = stream;
        video.play();
        Swal.hideLoading();
        Swal.close();
        this.refreshDeviceList();      })
      .catch(err => {
        this.camerror = err;
        Swal.close();
        console.error('Error al acceder a la cámara: ', err);
        if (err.name === 'OverconstrainedError') {
          console.error('La restricción que falló fue: ', err.constraint);

          this.cameraPermissionError = true;
           Swal.fire({
              icon: 'error',
              title: 'Error al acceder a la captura',
              text: 'Verifique su cámara antes de continuar. Error: ' + err.constraint.toString(),
              confirmButtonText: 'Aceptar'
            });

        }else{
            this.cameraPermissionError = true;
            Swal.fire({
              icon: 'error',
              title: 'Error al acceder a la captura',
              text: 'Verifique su cámara antes de continuar. Error: ',
              confirmButtonText: 'Aceptar'
            });
        }
      });
  }

  async refreshDeviceList(): Promise<void> {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        this.videoDevices = devices.filter(device => device.kind === 'videoinput');
      } catch (err) {
        console.error('Error al re-enumerar dispositivos: ', err);
      }
    }
  }

  requestCameraAccess(): void {
    this.cameraPermissionError = false;
    this.initializeCamera();
  }


  toggleCamera(): void {
    if (!this.frontCameraId || !this.rearCameraId) {
      return; 
    }

    const isUsingRear = this.selectedDeviceId === this.rearCameraId;
    const nextDeviceId = isUsingRear ? this.frontCameraId : this.rearCameraId;

    this.stopCamera();
    this.selectedDeviceId = nextDeviceId;
    
    this.triggerAutoFocus(); // Reset focus support on camera toggle
    setTimeout(() => this.startCamera(nextDeviceId), 100);
  }

  stopCamera(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => {
        track.stop();
      });
      this.stream = undefined;
      if (this.videoRef?.nativeElement) {
        this.videoRef.nativeElement.srcObject = null;
      }
    }
  }

  triggerAutoFocus(): void {
    if (!this.stream) return;
    const [videoTrack] = this.stream.getVideoTracks();
    if (videoTrack && typeof videoTrack.getCapabilities === 'function') {
      const capabilities = videoTrack.getCapabilities();

      if ((capabilities as any).focusMode && (capabilities as any).focusMode.includes('continuous')) {
        videoTrack.applyConstraints({
          advanced: [{
            focusMode: 'continuous'
          } as any]
        }).then(() => {
        }).catch(e => console.error("Error al aplicar el autofocus:", e));
      }
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.countdownInterval);
    this.stopCamera();
  }

  captureImage(): void {
    if (this.isCapturing) return;
  //  if(!this.uploading){
  //        this.uploading = true;
  //        Swal.fire({
  //          title: 'Procesando captura...',
  //          text: 'Se está procesando la imagen',
  //          allowOutsideClick: false,
  //          showConfirmButton: true,
  //          confirmButtonText: 'Cancelar ' + '(' + this.countdown + ')'
  //        }).then(result => {
  //          if (result.isConfirmed) {
  //            this.cancelPreview()
  //          }
  //        });
  //  }
    this.isCapturing = true;

    if (this.isPreviewing) {
      this.confirmCapture();
      return;
    }
    
    const video = this.videoRef.nativeElement;
    const canvas = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d');

    const width = video.videoWidth;
    const height = video.videoHeight;

    canvas.width = width;
    canvas.height = height;

 
    ctx?.drawImage(video, 0, 0, width, height); 
    this.capturedImage = canvas.toDataURL('image/png');
    this.previewImage = this.capturedImage;
    this.isPreviewing = true;
    this.isCapturing = false;

    if(this.capturesTaken + 1 < this.capturas){
        this.countdown = 1; //quedan varias
    }else{
        this.countdown = 3; //solo queda una
    } 
    
      Swal.fire({
      title: 'Procesando captura...',
        html: `
          <p>Se está procesando la imagen...</p>
          <div class="swal2-actions swal2-loading" style="display: flex;margin : 5px" >
            <div class="swal2-loader" style="display: flex;"></div>
          </div> `,
      allowOutsideClick: false,
      showConfirmButton: true,
      confirmButtonText: `Cancelar (${this.countdown})`,
      didOpen: () => {
       // Swal.showLoading();
        const confirmButton = Swal.getConfirmButton();
        if (confirmButton) {

          this.countdownInterval = setInterval(() => {
            this.countdown--;
            confirmButton.innerText = "Cancelar" + " (" +this.countdown + ")" ;
            if (this.countdown <= 0) {
              this.confirmCapture();
            }
          }, 1000);

        }
      }
    }).then(result => {
      if (result.isConfirmed) {
        this.cancelPreview();
      }
    });
  }

  private confirmCapture(): void {
    clearInterval(this.countdownInterval);
    if (!this.isPreviewing) return;

    this.isCapturing = true;

    this.capturedImages.push(this.capturedImage);

    const loadImage = (src: string): Promise<any> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = (err) => reject(err);
        img.src = src;
      });
    };

    Promise.all([loadImage(this.capturedImage), loadImage(this.currentmask)]).then(([finalImage, maskImg]) => {
        let maskDrawWidth: number, maskDrawHeight: number, maskX: number, maskY: number;
        const width = finalImage.width;
        const height = finalImage.height;

        const imageAspectRatio = width / height;
        const maskAspectRatio = maskImg.naturalWidth / maskImg.naturalHeight;

        if (imageAspectRatio > maskAspectRatio) {
          maskDrawHeight = height;
          maskDrawWidth = maskDrawHeight * maskAspectRatio;
        } else {
          maskDrawWidth = width;
          maskDrawHeight = maskDrawWidth / maskAspectRatio;
        }

        maskDrawWidth *= 1; //aqui depende de lo que tenga en el css, de momento ya puse en 100 el widht y el height
        maskDrawHeight *= 1;

        maskX = (width - maskDrawWidth) / 2;
        maskY = (height - maskDrawHeight) / 2; 

        const croppedCanvas = document.createElement('canvas');
        croppedCanvas.width = maskDrawWidth;
        croppedCanvas.height = maskDrawHeight;
        const croppedCtx = croppedCanvas.getContext('2d');
        if (!croppedCtx) return;

     
        const maskCanvas = document.createElement('canvas');
        maskCanvas.width = maskDrawWidth;
        maskCanvas.height = maskDrawHeight;
        const maskCtx = maskCanvas.getContext('2d');
        if (!maskCtx) return;

        // dibujo la máscara original en el canvas temporal
        maskCtx.drawImage(maskImg, 0, 0, maskDrawWidth, maskDrawHeight);

        // proceso los pixeles para hacerla totalmente opaca o totalmente transparente
        const imageData = maskCtx.getImageData(0, 0, maskDrawWidth, maskDrawHeight);
        const data = imageData.data;
        for (let i = 0; i < data.length; i += 4) {
          // aqui si tiene algo de opacidad hacerlo completamente opaco. si no, completamente transparente
          data[i + 3] = data[i + 3] > 100 ? 255 : 0;
        }
        maskCtx.putImageData(imageData, 0, 0);

        //uso la mascara procesada  para el recorte
        croppedCtx.drawImage(maskCanvas, 0, 0, maskDrawWidth, maskDrawHeight);
        croppedCtx.globalCompositeOperation = 'source-out';
        croppedCtx.drawImage(finalImage, maskX, maskY, maskDrawWidth, maskDrawHeight, 0, 0, maskDrawWidth, maskDrawHeight);

        this.croppedImages.push(croppedCanvas.toDataURL('image/png'));
        this.capturesTaken++;
        this.isCapturing = false;
        this.recuadroVisble = true;

        if (this.capturesTaken < this.capturas) {
          this.uploading = false;
          Swal.fire({
            title: `Captura ${this.capturesTaken} de ${this.capturas} guardada`,
            text: 'Mueva el material y capture la siguiente sección.',
          });
          this.isPreviewing = false;
        } else {
          Swal.fire({
            title: 'Preparando captura...',
            text: 'Esto podría tardar unos minutos',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          if(this.capturas == 1){
            Swal.showLoading();
            this.stitchImages().then(() => {
              this.saveCapture();
            });
          }
          else{
            this.uploading = false;
            Swal.close(); 
            this.isPreviewing = false;
          }
        }
    }).catch(error => {
      console.error(error);
      this.isCapturing = false;
      this.uploading = false;
    });
  }

  cancelPreview(): void {
    clearInterval(this.countdownInterval);
    this.isPreviewing = false;
    this.capturedImage = '';
    this.uploading = false;
    Swal.close();
  }

  async stitchImages(): Promise<void> {
    this.capturedImage = await this.stitch(this.capturedImages);
    this.croppedImage = await this.stitch(this.croppedImages);
  }

  stitch(images: string[]): Promise<string> {
      return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve('');
          return;
        }
  
        const imagePromises = images.map(src => new Promise<HTMLImageElement>(res => {
          const img = new Image();
          img.onload = () => res(img);
          img.src = src;
        }));
  
        Promise.all(imagePromises).then(loadedImages => {
          if (this.orientacion === 2) { 
            const maxWidth = Math.max(...loadedImages.map(img => img.width));
            const totalHeight = loadedImages.reduce((sum, img) => sum + img.height, 0);
            canvas.width = maxWidth;
            canvas.height = totalHeight;
  
            let currentY = 0;
            loadedImages.forEach(img => {
              ctx.drawImage(img, 0, currentY);
              currentY += img.height;
            });
  
          } else { 
            const totalWidth = loadedImages.reduce((sum, img) => sum + img.width, 0);
            const maxHeight = Math.max(...loadedImages.map(img => img.height));
            canvas.width = totalWidth;
            canvas.height = maxHeight;
  
            let currentX = 0;
            loadedImages.forEach(img => {
              ctx.drawImage(img, currentX, 0);
              currentX += img.width;
            });
          }
          resolve(canvas.toDataURL('image/png'));
        });
      });
    }

uploading = false;
saveCapture() {

      Swal.fire({
         title: 'Subiendo captura...',
         text: 'Esto podría tardar unos minutos',
         allowOutsideClick: false,
         didOpen: () => {
           Swal.showLoading();
         }
     });

       Swal.showLoading();
  const base64ToBlob = (base64: string, type = 'image/png') => {
    const byteString = atob(base64.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], { type });
  };

  const formData = new FormData();

  formData.append('imagenCompletaFile', base64ToBlob(this.capturedImage), 'original.png');
  formData.append('imagenRecorteFile', base64ToBlob(this.croppedImage), 'cropped.png');

  this.matService.capturedImage = this.capturedImage;
  this.matService.croppedImage = this.croppedImage;

  formData.append('idCampana', this.claw_camp_id.toString());
  formData.append('idGrupo', this.group_id.toString());
  formData.append('deviceInfo',  this.browserInfo + " " + " " + this.osInfo +" "+ this.deviceBrand);
  
  this.matService.uploadMaterialImage(formData).subscribe({
    next: (res) => {
      this.uploading = false;
      console.log('Subida exitosa', res)
      Swal.close(); 
      Swal.fire({
      icon: 'success',
      title: '¡Captura completada!',
      text: 'Tu imagen se ha capturado correctamente.',
      confirmButtonText: 'Aceptar'
    });
     this.isPreviewing = false;
    this.router.navigate(['/material-compare/'+ this.mainServide.serializeObj({apiRes : res, data : { material_img : this.dataParam.material_img,
       mat_nombre : this.dataParam.mat_nombre, mat_id : this.dataParam.mat_id, camp_id : this.dataParam.camp_id, box_id : this.dataParam.box_id, version : this.dataParam.version, isMirrored: this.isMirrored }})]);
    },
    error: (err) => {
      console.error('Error al subir', err);
      this.uploading = false;
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error al guardar la captura',
        text: 'Intenta nuevamente más tarde.',
        confirmButtonText: 'Reintentar'
      });
      this.capturesTaken = 0;
      this.isPreviewing = false;
      this.capturedImages = [];
      this.croppedImages = [];
    },
  });
}

toggleMirror() {
  this.isMirrored = !this.isMirrored;
}

nextMultipleCaptures(){
  this.stitchImages().then(() => {
    this.saveCapture();
  });
}

onRepetir(){
  this.capturedImage = '';
  this.croppedImage = ''; 
  this.capturesTaken = 0;
  this.capturedImages = [];
  this.croppedImages = [];
  this.isCapturing = false;
  this.recuadroVisble = false;
}

calcularAnchoRecuadro(): number {
  if (this.capturesTaken === 0) return 0; // Oculto inicialmente
  return (1 / this.capturas) * 100;
}

calcularPosicionLeft(): number {
  if (this.capturesTaken === 0) return 0;
    
  const anchoRecuadro = this.calcularAnchoRecuadro();
  return (this.capturesTaken - 1) * anchoRecuadro;
}
  
}
